// extracted by mini-css-extract-plugin
export default {"About":"About_About__pRfgF"};